import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { posts } from 'swag-client-common/redux/blog/blog.selectors';
import BlogPosts from './blog-posts';
const mapStateToProps = createStructuredSelector({
  posts
});
export default connect(mapStateToProps)(BlogPosts);